export enum BD {
  sicanets_sicanetsoftware = 'sicanets_sicanetsoftware',
  sicanet_merkavan = 'sicanet_merkavan',
  sicanets_atzin = 'sicanets_atzin'
}